
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import FooterModal from './FooterModals/FooterModal.vue';
import HeaderModal from './HeaderModals/HeaderModal.vue';

@Component({
  name: 'ModalC3',
  components: { HeaderModal, FooterModal }
})
export default class ModalC3 extends Vue {
  @Prop() switchId!: string;
  @Prop() switchDescription!: string;
  @Prop() eventDescription!: string;
  @Prop() activityDescription!: string;
  @Prop() sendNotification!: boolean;
  @Prop() idModal!: string;
  @Prop({ type: Function }) saveProcess!: any;
}
